import AppLayout from "../layout/AppLayout";
import AddressDetail from "./AddressDetail";

export default function AddressDetailWithLayout() {
  return (
    <AppLayout>
      <AddressDetail />
    </AppLayout>
  );
}
  
